import Typography from "@mui/material/Typography";
import { HeaderPage, MuiLayout, SupportedLocale, useCommonMenuLinkItems } from "@lectra/mui-library";
import { AuthentUtils, useAuthenticationValue } from "@lectra/react-authentication";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

type Props = {
    children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({children}) => {
    const navigate = useNavigate();
    const {actions, user} = useAuthenticationValue();
    const {myLectra, userProfile} = useCommonMenuLinkItems(
        'DEV',
        [
            {
                siteId: user && user[AuthentUtils.APP_METADATA].attachment_site,
                permissions:
                    user && user[AuthentUtils.APP_METADATA].permissions,
            },
        ]
    );

    const {inProgress, instance} = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const handleLogout = (logoutType: string) => {
        if (logoutType === "popup") {
            void instance.logoutPopup({
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            void instance.logoutRedirect();
        }
    }
    const handleLogin = (loginType: string) => {
        if (loginType === "popup") {
            void instance.loginPopup(loginRequest);
        } else if (loginType === "redirect") {
            void instance.loginRedirect(loginRequest);
        }
    }

    const appTitle = {
        label: "POC MS Identity Platform",
        action: () => navigate('/'),
    };

    return (
        <MuiLayout
            header={{
                lang: SupportedLocale.EN,
                appTitle,
                userProfileProps: {
                    user: {
                        firstName: user?.given_name ?? "",
                        lastName: user?.family_name ?? "",
                        email: user?.email ?? ""
                    },
                    userProfile,
                    myLectra,
                    logoutAction: actions?.logout,
                },
                optionsMenuProps: {
                    actions: [...(isAuthenticated ? [
                        {
                            action: () => handleLogout("popup"),
                            label: "Logout using Popup",
                        },
                        {
                            action: () => handleLogout("redirect"),
                            label: "Logout using Redirect",
                        },
                    ] : (inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect ? [
                        {
                            action: () => handleLogin("popup"),
                            label: "Sign in using Popup",
                        },
                        {
                            action: () => handleLogin("redirect"),
                            label: "Sign in using Redirect",
                        },
                    ] : []))]
                }
            }}
        >
            <>
                <HeaderPage
                    titleSection={
                        <Typography variant="h2" color="primary">
                            Welcome to the Microsoft Authentication Library For React Quickstart
                        </Typography>
                    }
                />
                {children}
            </>
        </MuiLayout>
    );
};